import React from 'react';
import { Form, FormControl } from 'react-bootstrap';
import userImg from '../../assets/images/chat/user3.png';

const SideBar = ({
  users,
  handleSelectUser,
  searchInput,
  setSearchInput,
  active,
}) => {
  const handleChange = (e) => {
    setSearchInput(e.target.value);
  };

  return (
    <div className='people-list' id='people-list'>
      <div className='people-list-header'>
        <div className='quick-request'>
          <h6>Quick Requests</h6>
        </div>
        <div className='search-wrapper'>
          <div className='search-box'>
            <Form className='search-box-form'>
              {/* <Button> */}
              <SearchIcon />
              {/* </Button> */}
              <FormControl
                type='search'
                value={searchInput}
                onChange={handleChange}
                placeholder='Search'
                aria-label='Search'
              />
            </Form>
          </div>
        </div>
      </div>
      <div className='people-list-wrapper'>
        <ul className='list'>
          {users &&
            users?.length > 0 &&
            users?.map((specificUser, i) => (
              <li
                onClick={() => handleSelectUser(specificUser, i)}
                key={`item-${i}`}
                className={`clearfix ${active === i && 'active'}`}
              >
                <div className='about'>
                  <img
                    src={(specificUser && specificUser?.avatar[0]) || userImg}
                    alt='avatar'
                  />
                  <div className='about-name-email'>
                    <div className='name'>{specificUser.userName[0]}</div>
                    <div className='email-about'>{specificUser.email[0]}</div>
                  </div>
                </div>
                {specificUser.totalUnread !== 0 && (
                  <div className='msg-time-grid'>
                    {specificUser.totalUnread}
                  </div>
                )}
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

export default SideBar;

export const SearchIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M10.4004 2.3999C5.99159 2.3999 2.40039 5.9911 2.40039 10.3999C2.40039 14.8087 5.99159 18.3999 10.4004 18.3999C12.3176 18.3999 14.0783 17.7191 15.4582 16.589L20.2348 21.3655C20.3085 21.4423 20.3968 21.5036 20.4945 21.5458C20.5922 21.5881 20.6973 21.6104 20.8038 21.6115C20.9102 21.6125 21.0158 21.5924 21.1143 21.5521C21.2129 21.5119 21.3024 21.4524 21.3776 21.3772C21.4529 21.3019 21.5124 21.2124 21.5526 21.1138C21.5929 21.0153 21.613 20.9097 21.6119 20.8033C21.6109 20.6968 21.5886 20.5917 21.5463 20.494C21.5041 20.3963 21.4428 20.308 21.366 20.2343L16.5895 15.4577C17.7196 14.0778 18.4004 12.3171 18.4004 10.3999C18.4004 5.9911 14.8092 2.3999 10.4004 2.3999ZM10.4004 3.9999C13.9445 3.9999 16.8004 6.8558 16.8004 10.3999C16.8004 13.944 13.9445 16.7999 10.4004 16.7999C6.85629 16.7999 4.00039 13.944 4.00039 10.3999C4.00039 6.8558 6.85629 3.9999 10.4004 3.9999Z'
        fill='#616975'
      />
    </svg>
  );
};
